import { ReactElement } from 'react';

import { IconsPropsI } from './interfaces';

const SolidPersonIcon = ({
  width = 10,
  height = 10,
  fill = '#FFFFFF',
  alternativeFill = 'white',
}: IconsPropsI): ReactElement => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.22233 2.77691C7.22233 4.00469 6.22789 4.99913 5.00011 4.99913C3.77233 4.99913 2.77789 4.00469 2.77789 2.77691C2.77789 1.54913 3.77233 0.554688 5.00011 0.554688C6.22789 0.554688 7.22233 1.54913 7.22233 2.77691ZM0.555664 8.33247C0.555664 6.85469 3.51677 6.11024 5.00011 6.11024C6.48344 6.11024 9.44455 6.85469 9.44455 8.33247V8.88802C9.44455 9.19358 9.19455 9.44358 8.889 9.44358H1.11122C0.805664 9.44358 0.555664 9.19358 0.555664 8.88802V8.33247Z"
        fill={fill}
      />
    </svg>
  );
};

export default SolidPersonIcon;
